import React from "react";
import { Helmet } from "react-helmet-async";

const ProjectsSEO = () => {
  return (
    <Helmet>
      <title>Projects by Themiya Induwara | Portfolio Showcase</title>
      <meta
        name="description"
        content="Explore Themiya Induwara's portfolio of projects including Vehicle Recommendation System, Password Generator, Botsix Lanka, and Cotezco e-commerce platform."
      />
      <meta
        name="keywords"
        content="Themiya Projects, Full Stack Projects, React Projects, Web Development Portfolio, Mobile App Projects, Sri Lankan Developer Projects, Themiya Portfolio"
      />
      <link rel="canonical" href="https://themiya.dev/projects" />
    </Helmet>
  );
};

export default ProjectsSEO;
